import React from "react";
import { Grid } from "@mui/material";
import { getAssets } from "@unisearch/helpers";
import styles from "./diversify.module.scss";
import InfoDropdown from "../components/info_dropdown";

const data = [
  {
    id: 1,
    title: "Live chats",
    description:
      "Cut down inbox clutter and the risk of emails getting lost in Spam folders. Connect with students in real-time through our live messaging feature.",
  },
  {
    id: 2,
    title: "Live events",
    description:
      "Organise, host, and participate in live virtual events - including UniSearch’s monthly online fairs - to build your university’s global presence among diverse students in emerging markets.",
  },
  {
    id: 3,
    title: "Blog posts and rich media",
    description:
      "Alongside managing your courses and profile, you have complete control in building your university’s media gallery, sharing blog and vlog posts, and other rich media statistically likely to engage more students.",
  },
];

export const UniPageQualityDiversify = () => {
  return (
    <section className={styles.section_diversify}>
      <div className="container">
        <Grid container spacing={3} alignItems="center">
          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/unipage/uni_hat_throw.png")}
                alt="University hat throw"
              />
            </div>
          </Grid>
          <Grid item sm={12} md={6}>
            <h2 className={styles.title}>
              How We Help You Connect with Best-Fit Prospects
            </h2>
            <p className={`${styles.sub_title} font-medium`}>
              Our experience shows how connecting with students one-to-one can
              greatly impact university choice and application decisions. Build
              lasting relationships with best-fit prospects through:
            </p>
            <div className={styles.dropdown_wrapper}>
              <InfoDropdown data={data} style={{ boxShadow: "none" }} />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UniPageQualityDiversify;
